const IMG_PROXY = 'https://phosphor.utils.elfsightcdn.com/';

export const getMediaWithProxy = (src: string | undefined) => {
  if (!src) return '';

  return `${IMG_PROXY}?url=${encodeURIComponent(src)}`;
};
